export const INACTIVE_COLOR = "#D3D3D3";

export const DEFAULT_COLORS = [
    '#449995',
    '#86C5A9',
    '#EACD6D',
    '#009B96',
    '#DC5C1E',
    '#F1883C',
    '#71C7A7',
    '#EAB235',
    '#3366CC', '#DC3912', '#FF9900', '#109618',
    '#3B3EAC', '#0099C6', '#DD4477', '#66AA00',
    '#316395', '#994499', '#22AA99', '#AAAA11',
];